import './app.css';
import { App } from './app';

// Initialize the application
document.addEventListener('DOMContentLoaded', async () => {
  const app = new App();
  await app.init();
});

